import { batch, computed, signal } from "@preact/signals-react"

// List data: one entry per duplicated (site, SKU) group
export const groups = signal([])
export const totalCount = signal(0)
export const currentPage = signal(0)
export const pageSize = signal(50)
export const hasSearched = signal(false)
export const loadError = signal(false)
// Activity window of the last response: { activeSince: 'YYYY-MM-DD', includeInactive: bool }
export const activityWindow = signal(null)

// Edit mapping drawer: { raw, sku }
export const editMappingDrawer = signal(null)

// Image comparison modal (for SKU vs Raw comparison)
export const imageComparisonModal = signal(null)

// Loading states
export const isLoadingFilters = signal(false)
export const isLoadingList = signal(false)

// Filters (no date range). By default only products seen in the last 30 days count: most older
// mappings are retired product_ids, not mapping errors. includeInactive brings the whole history back.
export const selectedMarkets = signal([])
export const selectedSites = signal([])   // array of option objects: [{value, label, countryCode}]
export const sitesOptions = signal([])
export const selectedBrands = signal([])
export const includeInactive = signal(false)

export const filtersValue = computed(() => ({
    markets: selectedMarkets.value || [],
    sites: (selectedSites.value || []).map(s => s.value),
    brands: selectedBrands.value || [],
    includeInactive: includeInactive.value
}))

// Filters of the last Search: paging keeps them even if the form was edited afterwards
export const submittedFilters = signal(null)

// The backend searches site by site, so a market or a site is required
export const canSearch = computed(() =>
    selectedMarkets.value.length > 0 || selectedSites.value.length > 0
)

// A remapped product no longer belongs to its group; a group left with one product is no longer a duplicate
export const removeProductFromGroup = (idSite, idSku, productId) => {
    let removedGroup = false
    groups.value = groups.value.flatMap(group => {
        if (group.id_site !== idSite || group.sku.id_sku !== idSku) return [group]
        const products = group.products.filter(p => p.product_id !== productId)
        if (products.length < 2) {
            removedGroup = true
            return []
        }
        return [{ ...group, products, n_products: products.length }]
    })
    if (removedGroup) totalCount.value = Math.max(totalCount.value - 1, 0)
}

export const markProductValidated = (idSite, idSku, productId) => {
    groups.value = groups.value.map(group => {
        if (group.id_site !== idSite || group.sku.id_sku !== idSku) return group
        return {
            ...group,
            products: group.products.map(p => p.product_id === productId ? { ...p, validated: true } : p)
        }
    })
}

export const clearSkuDuplicatesSignals = () => batch(() => {
    groups.value = []
    totalCount.value = 0
    currentPage.value = 0
    pageSize.value = 50
    hasSearched.value = false
    submittedFilters.value = null
    loadError.value = false
    isLoadingFilters.value = false
    isLoadingList.value = false
    selectedMarkets.value = []
    selectedSites.value = []
    selectedBrands.value = []
    includeInactive.value = false
    activityWindow.value = null
    editMappingDrawer.value = null
    imageComparisonModal.value = null
})
